import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AiOrderParserBatchListConfigService } from '../../../services/ai-order-parser-review/ai-order-parser-batch-list-config.service';
import { AuthService } from '../../../services/auth/auth.service';

/**
 * Section nav for the order-parser views (hub, inbox, single upload, configs):
 * the section name as home link plus underline tabs, so users can move between
 * the views without round-tripping through the hub. The inbox tab carries the
 * AWAITING_REVIEW count — the one number that is a call to action.
 */
@Component({
  selector: 'lib-pdf-ai-parser-nav',
  standalone: false,
  templateUrl: './pdf-ai-parser-nav.component.html',
  styleUrl: './pdf-ai-parser-nav.component.scss'
})
export class PdfAiParserNavComponent implements OnInit {
  private listConfig = inject(AiOrderParserBatchListConfigService);
  private router = inject(Router);
  private authService = inject(AuthService);

  isAdmin$: Observable<boolean> = this.authService
    .getRoles()
    .pipe(map(roles => (roles || []).includes('ADMIN')));

  needsReview$: Observable<number> = this.listConfig
    .getRawItems()
    .pipe(map(items => (items || []).filter(item => item.status === 'AWAITING_REVIEW').length));

  ngOnInit(): void {
    // Fresh badge count wherever the nav renders. The inbox view (now at
    // /order-parser itself) reloads the same list in its own ngOnInit, so skip
    // the duplicate request there. Compare the path only — ignore query params.
    if (this.router.url.split('?')[0] !== '/order-parser') {
      this.listConfig.reload();
    }
  }
}
